import { render, staticRenderFns } from "./Astron.vue?vue&type=template&id=76b05500&"
import script from "./Astron.vue?vue&type=script&lang=js&"
export * from "./Astron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports